import { render, staticRenderFns } from "./SelectableImage.vue?vue&type=template&id=483bbfb2&scoped=true"
import script from "./SelectableImage.vue?vue&type=script&lang=ts"
export * from "./SelectableImage.vue?vue&type=script&lang=ts"
import style0 from "./SelectableImage.vue?vue&type=style&index=0&id=483bbfb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483bbfb2",
  null
  
)

export default component.exports